import React from "react";
import { experimentalStyled, Container, Box, Link } from "@mui/material";
import { Outlet } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import placeholder from "../../src/images/PPKM_Logo.png";

const MainWrapper = experimentalStyled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  width: "100%",
}));

const PageWrapper = experimentalStyled(Box)(({ theme }) => ({
  flex: "1",
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const EventRegistrationFormLayout = () => {
  return (
    <MainWrapper
      sx={{
        backgroundColor: "#e8e8e8",
      }}
    >
      <PageWrapper>
        <Container
          maxWidth="lg"
          sx={{
            flex: "1",
          }}
        >
          <Card sx={{ mb: 4 }}>
            <CardMedia
              component="img"
              sx={{ width: 250, height: 50, mx: "auto", mt: 2 }}
              image={placeholder}
              alt="Live from space album cover"
            />
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Tel: 603-7727 6232
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", display: "flex", gap: 2 }}
              >
                <span>
                  Email:{" "}
                  <Link href="secretariat@ppkm.org.my" underline="hover">
                    secretariat@ppkm.org.my
                  </Link>
                </span>
                <span>Website: www.ppkm.org.my</span>
              </Typography>
            </CardContent>
          </Card>

          <Outlet />
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default EventRegistrationFormLayout;
